import React from "react";
import {
  Input,
  message,
  Select,
  Button,
  Space,
  Row,
  Col,
  Modal,
  Tooltip,
  Image,
  Drawer,
  Avatar,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import LicenseControlStore from "../store/LicenseControlStore";
import VehicleStore from "../store/VehicleStore";
import LicenseControladd from "./LicenseControladd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import dayjs from "dayjs";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

class LicenseControlTab extends React.Component {
  constructor(props, context) {
    super(props);

    this.companyStore = new CompanyStore(this);
    this.licenseControlStore = new LicenseControlStore();
    this.vehicleStore = new VehicleStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",
      assetName: "",
      deviceId: "",
      company_value_label: "",
      openSensorForm: false,
      editData: {},
      openDeleteModal: false,
      deleteData: {},
      listUpdated: 0,
      visibleRows: {},
    };

    this.columns = [
      {
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "companyName",
        width: 150,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_ASSET_NAME_"),
        dataIndex: "vehicleNo",
        width: 150,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_FLEET_REPORTS_VEHICLEREPORT_DEVICE_"),
        dataIndex: "deviceId",
        width: 120,
        ellipsis: { showTitle: true },
      },
      {
                title: context.translate("_ENCRYPTED_LICENSE_NUMBER_"),
                dataIndex: "encryptedLicenseNumber",
                width: 180,
                render: (val, record) => {
                    const isVisible = this.state.visibleRows[record.id];

                    return (
                    <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                        <Tooltip title={isVisible ? val : "•••••••••••••••"}>
                        <span>
                            {isVisible ? val : "•••••••••••••••"}
                        </span>
                        </Tooltip>

                        <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.setState((prev) => ({
                            visibleRows: {
                                ...prev.visibleRows,
                                [record.id]: !prev.visibleRows[record.id],
                            },
                            }));
                        }}
                        >
                        {isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                        </span>
                    </div>
                    );
                },
                },
     {
        title: context.translate("_DATE_TIME_"),
        dataIndex: "dateTime",
        width: 180,
        ellipsis: { showTitle: true },
        render: (value) =>
            value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "",
    },
    //   {
    //     title: context.translate("_HUMIDITY_CALIBRATION_FACTOR_"),
    //     dataIndex: "humidityCalFactor",
    //     width: 200,
    //     ellipsis: { showTitle: true },
    //   },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        width: 80,
        align: "center",
        render: (_, record) => (
          <Space>
           

             {/* <Tooltip
                title={this.context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
                placement="top"
              >
                                 <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
              </Tooltip> */}
              <Tooltip
                title={this.context.translate("_FLEET_USER_USERLIST_DELETE_")}
                placement="bottom"
              >
                <Image
                  preview={false}
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer", width: "15px" }}
                  onClick={() =>
                    this.setState({ openDeleteModal: true, deleteData: record })
                  }
                />
              </Tooltip>

          </Space>
        ),
      },
    ];
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  handleSearch = async () => {
    this.setState({ loading: true });
    await this.licenseControlStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      assetName: this.state.assetName,
      deviceId: this.state.deviceId,
    });
    await this.setState({ listUpdated: 1, loading: false });
  };

  handleTableChange = async (pagination) => {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  };

  handleChange = async ({ comp }) => {
    if (comp) {
      await this.setState({ currentPage: 1, companyId: comp.value, pageSize: 50 });
      const singleData = await this.companyStore.getCompanyDataById(comp.value);
      await this.vehicleStore.getVehiclesCompanyId(comp?.value);
      const vehicle = await this.vehicleStore.getVehiclesCompanyId(comp?.value);
      console.log("vehicle",vehicle);
      await this.setState({ company_value_label: singleData });
      await this.handleSearch();
    }
  };

  onEdit = async (record) => {
    await this.setState({ openSensorForm: true, editData: record });
  };

  onDelete = async (record) => {
    const response = await this.licenseControlStore.deleteRecord({ 
      Id: record.id || record.Id, 
      companyId: record.companyId 
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };

  responseMsg = async (resp) => {
    if (resp.data.success === "S") {
      message.success(resp.data.message);
      await this.setState({ openSensorForm: false, editData: {} });
      await this.handleSearch();
    } else {
      message.error(resp.data.message);
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.licenseControlStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  handleClear = async () => {
    await this.setState({ company_value_label: null, companyId: "" });
  };

  handleExport = () => {
    if (!this.licenseControlStore?.licenses?.length) return;
    const result = this.columns.map((col) => col.dataIndex);
    this.licenseControlStore.exportExcel({
      companyId: this.state.companyId,
      colList: result,
      deviceId:this.state.deviceId,

    });
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(comp) => this.handleChange({ comp })}
                  value={this.state.company_value_label || null}
                  allowClear
                  onClear={this.handleClear}
                  style={{ width: 165 }}
                  fromAccountList={1}
                />

                {/* <Select
                  className="searchInput"
                  style={{ width: 150 }}
                  placeholder={this.context.translate("_ASSET_NAME_")}
                  value={this.state.assetName || null}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  onChange={async (val) => {
                    await this.setState({ assetName: val ?? "" });
                    await this.handleSearch();
                  }}
                  options={this.vehicleStore?.getVehiclesUsingCompanyId?.map((a) => ({
                    value: a.vehicleId,
                    label: a.vehicleNo,
                  }))}
                /> */}

                <Input
                  className="searchInput"
                  placeholder={this.context.translate("_SEARCH_BY_VEHICLE_NUMBER_")}
                  value={this.state.deviceId}
                  style={{ width: 300, borderRadius: "20px" }}
                  onChange={async (e) => {
                    await this.setState({ deviceId: e.target.value });
                    if (!e.target.value) await this.handleSearch();
                  }}
                  onPressEnter={this.handleSearch}
                />

                {/* <Input
                  className="searchInput"
                  placeholder={this.context.translate("_SENSOR_NAME_")}
                  value={this.state.sensorName}
                  style={{ width: 150, borderRadius: "20px" }}
                  onChange={async (e) => {
                    await this.setState({ sensorName: e.target.value });
                    if (!e.target.value) await this.handleSearch();
                  }}
                  onPressEnter={this.handleSearch}
                /> */}
              </Space>
            </Col>

            <Col
              style={{ display: "flex", alignItems: "center", justifyContent: "end" }}
              span={8}
            >
              <Space>
                {/* <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{ height: 18, marginInlineEnd: "20px", cursor: "pointer" }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({ assetName: "", sensorId: "" });
                    }}
                  />
                </Tooltip> */}

                <Tooltip
                  title={this.context.translate("_DOWNLOAD_")}
                  placement="bottom"
                >
                  <span>
                    <Button
                      className="downloadExcelButton"
                      disabled={!this.licenseControlStore?.licenses?.length}
                      onClick={this.handleExport}
                    >
                      <Image style={{ height: 18, width: "auto" }} src={downloadIcon} />
                    </Button>
                  </span>
                </Tooltip>

                {/* {this.props.canCreate("sensordetails") &&
                  Number(this.props.getUserData().isadmin) !== 0 && (
                    <Button
                      className="addButtonClass"
                      onClick={() => this.setState({ openSensorForm: true, editData: {} })}
                    >
                      <Image
                        style={{ marginInlineEnd: "5px", width: 13 }}
                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                      />
                      {this.context.translate("_ADD_")}
                    </Button>
                  )} */}
                  
                    <Button
                      className="addButtonClass"
                      onClick={() => this.setState({ openSensorForm: true, editData: {} })}
                    >
                      <Image
                        style={{ marginInlineEnd: "5px", width: 13 }}
                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                      />
                      {this.context.translate("_ADD_")}
                    </Button>
              </Space>
            </Col>
          </Row>

          {/* Add / Edit Drawer */}
          {this.state.openSensorForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openSensorForm}
              footer={false}
              placement={
                this.context.locale.language === "english" ? "right" : "left"
              }
              title={
                <div className="formTitle">
                  {this.context.translate("_LICENSE_CONTROL_DETAILS_")}
                  <p className="formDescription">
                    {this.context.translate("_LICENSE_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onCancel={() => this.setState({ openSensorForm: false, editData: {} })}
            >
              <LicenseControladd
                editData={this.state.editData}
                response={this.responseMsg}
                closeModal={() => this.setState({ openSensorForm: false, editData: {} })}
              />
            </Drawer>
          )}

          {/* Delete Confirm Modal */}
          {this.state.openDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              centered
              open={this.state.openDeleteModal}
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ openDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>
                <Button
                  className="deleteModalOkButton"
                  onClick={() => this.onDelete(this.state.deleteData)}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.licenseControlStore?.total}
            columns={this.columns}
            dataSource={this.licenseControlStore?.licenses}
            loading={this.licenseControlStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}

LicenseControlTab.contextType = StoreContext;
export default observer(withRouter(LicenseControlTab));